import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { UserAccountResource } from '../_resources/user-account.resource';
import { AuthService } from '../_services/auth.service';
import { ErrorHandler } from '../_services/error-handler.factory';
import { LocalTrackingSettingsService } from 'app/_services/localTrackingSettingsService';

class ChangeTrackingPreferencesComponent implements ng.IController {
    protected allowTracking = false;
    protected lastChangeDate: Date;
    protected togglingTracking = false;
    protected user: LoginResult;

    constructor(
        private userAccountResource: UserAccountResource,
        private authService: AuthService,
        private errorHandler: ErrorHandler,
        private growl: Growl,
        private localTrackingSettingsService: LocalTrackingSettingsService
    ) {}

    $onInit(): void {
        this.authService.userLoginPromise.promise.then((user) => {
            this.user = user;
            if (
                user.trackingSettings &&
                !angular.isUndefined(user.trackingSettings.allow)
            ) {
                this.allowTracking = user.trackingSettings.allow;
                this.lastChangeDate = user.trackingSettings.date as Date;
            } else {
                // first set in this session, so take from local settings
                const local = this.localTrackingSettingsService.load();
                if (!angular.isUndefined(local.allow)) {
                    this.allowTracking = local.allow;
                    this.lastChangeDate = local.date;
                }
            }
        });
    }

    public toggleTracking() {
        if (this.togglingTracking) {
            return;
        }
        this.togglingTracking = true;
        const date = new Date();
        this.userAccountResource
            .changeTrackingSettings(
                {},
                {
                    allowTracking: !this.allowTracking,
                    date
                }
            )
            .$promise.then((acc) => {
                if (acc.allowTracking === this.allowTracking) {
                    throw new Error(
                        'New setting does not match required setting'
                    );
                }
                this.allowTracking = acc.allowTracking;
                this.togglingTracking = false;
                this.growl.show(
                    'Successfully saved cookie preference!',
                    'success',
                    {
                        delay: 2000,
                        allowDismiss: true
                    }
                );
                this.localTrackingSettingsService.set(this.allowTracking, date);
                // to update the preference in the current session if user revisits this page, retrigger the login promise
                this.user.trackingSettings = {
                    allow: this.allowTracking,
                    date
                };
                this.authService.userLoginPromise.resolve(this.user);
                this.lastChangeDate = date;
            })
            .catch((err) => {
                this.togglingTracking = false;
                this.errorHandler(err);
            });
    }
}

angular.module('app').component('pkpChangeTrackingPreferences', {
    controller: ChangeTrackingPreferencesComponent,
    template: require('app/_directives/change-tracking-preferences.component.html')
});
